import { prop, Vue } from 'vue-class-component'
import { Config } from '@/config'

type PageItem = number | '...'

// Define props in a class
class Props {
  currentPage = prop({
    type: Number,
    required: true,
    default: 1
  });

  totalRecords = prop({
    type: Number,
    required: true
  });

  perPage = prop({
    type: Number,
    required: false,
    default: Config.PAGINATION.PER_PAGE
  });
}

export default class Pagination extends Vue.with(Props) {
  private readonly MAX_VISIBLE_PAGES = 7

  get totalPages (): number {
    return this.perPage > 0
      ? Math.ceil(this.totalRecords / this.perPage)
      : 0
  }

  get pageNumbers (): PageItem[] {
    const pages: PageItem[] = []
    const totalPages = this.totalPages

    if (totalPages <= this.MAX_VISIBLE_PAGES) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (this.currentPage <= 3) {
        pages.push(1, 2, 3, '...', totalPages)
      } else if (this.currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages)
      } else {
        pages.push(1, '...', this.currentPage, '...', totalPages)
      }
    }

    return pages
  }

  goToPage (page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.$emit('pageChange', page)
      this.scrollToParent()
    }
  }

  previousPage (): void {
    if (this.currentPage > 1) {
      this.$emit('pageChange', this.currentPage - 1)
      this.scrollToParent()
    }
  }

  nextPage (): void {
    if (this.currentPage < this.totalPages) {
      this.$emit('pageChange', this.currentPage + 1)
      this.scrollToParent()
    }
  }

  onGotoPageChange (event: Event): void {
    const target = event.target as HTMLSelectElement
    const page = parseInt(target.value)
    this.goToPage(page)
  }

  scrollToParent (): void {
    this.$nextTick(() => {
      const parentElement = this.$el.closest('.container-wrap')
      if (parentElement) {
        parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }
}
